import { useMemo, useState } from "react";

export function useToggleState(
  initialState: boolean | (() => boolean) = false,
): readonly [
  boolean,
  { enable: () => void; disable: () => void; toggle: () => void },
] {
  const [isToggled, setToggled] = useState(initialState);

  const actions = useMemo(
    () => ({
      enable: () => {
        setToggled(true);
      },
      disable: () => {
        setToggled(false);
      },
      toggle: () => {
        setToggled((prev) => !prev);
      },
    }),
    [],
  );

  return useMemo(() => [isToggled, actions] as const, [actions, isToggled]);
}
